export const GET_PLACES = 'GET_PLACES';
export const GET_PLACES_FOR_MAP = 'GET_PLACES_FOR_MAP';
export const SET_CHOSEN_PLACE = 'SET_CHOSEN_PLACE';
export const PLACE_IMAGE_UPLOADED = 'PLACE_IMAGE_UPLOADED';
export const GET_CITIES_FOR_MAP = 'GET_CITIES_FOR_MAP';
export const GET_TAGS_FOR_MAP = 'GET_TAGS_FOR_MAP';

